<template>
  <div id="app" :class="{ 'inventory-only': isInventoryOnly }" @click="clickOutSide()">

    <Nav @messageFromNav="messageFromNavReceived" />
    <div class="mainContainer">

      <!-- Integration Info Banner -->

      <div v-if="isIntegration"
        style="position: fixed;width: 100%;height: 28px; left: 0; top: 0; z-index: 10000; background-color: orange;text-align: center; line-height: 28px;opacity: 0.8;pointer-events: none;">
        INTEGRATION STAGE</div>

      <!-- Error Alert -->

      <b-alert :show="dismissCountDown" dismissible :variant="getAlert.alertVariant" @dismissed="dismissCountDown = 0"
        @dismiss-count-down="countDownChanged">
        {{ getAlert.alertText }}
        <b-progress variant="warning" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress>
      </b-alert>

      <div v-if="isAuthenticated && venueChosen" class="topbar">
        <TopBarHeadline v-if="getShowTopBarHeadline" />
        
        <div></div>

        <div class="topbar-right">
          <a @click="resetChosenVenue">
            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <g fill="#0CBA4A" fill-rule="nonzero">
                <path
                  d="M21 5h2v14h-2V5zm-4 0h2v14h-2V5zm-3 0H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-1 12H3V7h10v10z" />
                <path
                  d="M11 11.233C11 9.34 9.675 8 8 8s-3 1.34-3 3.233c0 1.22.975 2.837 3 4.767 2.025-1.93 3-3.546 3-4.767z" />
              </g>
            </svg>
            {{ venueTitle }}
          </a>
          <a v-b-modal.modal-activities>
            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13 3a9 9 0 0 0-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0 0 13 21a9 9 0 0 0 0-18zm-1 5v5l4.25 2.52.77-1.28-3.52-2.09V8H12z"
                fill="#0CBA4A" fill-rule="nonzero" />
            </svg>
          </a>
          <a v-b-modal.modal-settings>
            <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9 0C4.032 0 0 4.032 0 9s4.032 9 9 9 9-4.032 9-9-4.032-9-9-9zm5.724 13.347C13.437 11.781 10.314 11.25 9 11.25s-4.437.531-5.724 2.097A7.155 7.155 0 0 1 1.8 9c0-3.969 3.231-7.2 7.2-7.2 3.969 0 7.2 3.231 7.2 7.2a7.155 7.155 0 0 1-1.476 4.347zM9 4.5a3.366 3.366 0 0 0-3.375 3.375A3.366 3.366 0 0 0 9 11.25a3.366 3.366 0 0 0 3.375-3.375A3.366 3.366 0 0 0 9 4.5z"
                fill="#0CBA4A" fill-rule="nonzero" />
            </svg>
          </a>
        </div>
      </div>

      <ActivitiesModal ref="modal-activities" />

      <SettingsModal ref="modal-settings" />

      <router-view />

      <PlaySmartListEditModal v-if="isAuthenticated && venueChosen" ref="playSmartListEditModal" />

    </div>
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import { mapGetters } from 'vuex'
import DataService from '@/services/StrapiService'
import PlaySmartListEditModal from '@/components/modals/PlaySmartListEditModal.vue'
import ActivitiesModal from '@/components/modals/ActivitiesModal.vue'
import SettingsModal from '@/components/modals/SettingsModal.vue'
import TopBarHeadline from './components/inventory/TopBarHeadline.vue'

export default {
  name: 'App',
  components: {
    Nav, PlaySmartListEditModal, ActivitiesModal, SettingsModal, TopBarHeadline
  },
  created() {
    if (this.getUser.language != null && this.getUser.language.languageKey != null) {
      this.$i18n.locale = this.getUser.language.languageKey
    } else {
      this.$i18n.locale = navigator.language || navigator.userLanguage
    }
  },
  data() {
    return {
      dismissSecs: 4,
      dismissCountDown: 0,
      dismissAlertText: 'Hallo',
      isIntegration: DataService.isIntegration()
    }
  },
  methods: {
    resetChosenVenue() {
      this.$store.commit('updateVenue', {})
      this.$router.push('/venues')
    },
    messageFromNavReceived(arg1) {
      if (arg1 === 'addPlaylist') {
        this.$refs.playSmartListEditModal.showModal()
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
      if (dismissCountDown == 0) {
        var alertobject = {
          text: '',
          variant: 'info'
        }
        this.$store.commit('setAlertText', alertobject)
      }
    },
    clickOutSide() {
      this.$store.commit('clickedOutside')
    },
    goTo(link) {
      if (link) {
        this.$router.push(link)

      }
    }
  },
  computed: {
    venueTitle: function () {
      return this.getVenue.attributes != null ? this.getVenue.attributes.title : ''
    },
    loggedIn: function () {
      return this.getUser.username != null
    },
    ...mapGetters(['isAuthenticated', 'venueChosen', 'getUser', 'getVenue', 'getShowPlaylistPopup', 'getAlert', 'getLocales', 'getShowTopBarHeadline', 'isInventoryOnly'])
  },
  watch: {
    getAlert: {
      handler(to) {
        if (to.alertText != '') {
          this.dismissCountDown = this.dismissSecs
        }
      }, deep: true
    }
  }
}
</script>